import { createContext, useContext } from 'react';
import type { User } from 'firebase/auth';

export interface AuthContextType {
    user: User | null;
    loading: boolean;
    switchUser: (uid: string) => void;
    signInWithEmail: (email: string, pass: string) => Promise<User>;
}

export const AuthContext = createContext<AuthContextType>({
    user: null,
    loading: true,
    switchUser: () => { throw new Error("Auth not initialized"); },
    signInWithEmail: () => Promise.reject(new Error("Auth not initialized"))
});

export const useAuth = () => useContext(AuthContext);
